import attentionreply from './attentionreply';
import create from './create';
import keyreply from './keyreply';
import PicWordMsg from './picWordMsg';
import ReplyRuleCreate from './replyRuleCreate';
import Qrcode from './qrcode';
import Payment from './payment';

export default {
  namespaced: true,
  modules: { attentionreply, create, keyreply, PicWordMsg, ReplyRuleCreate, Qrcode, Payment },
};
